import React from 'react';
import { Typography, Stack, Box, styled } from '@mui/material';
import { ResponsiveSVG } from 'components/ResponsiveSVG/ResponsiveSVG';
import NotFoundImage from 'assets/images/ErrorState/UnexpectedErrorTwo.svg';
import { Button } from 'components/Button/Button';
import { useNavigate } from 'features/cobrand/hooks/useCobrandUtils';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface NotFoundProps {
  hideBackHomeButton?: boolean;
  backHomeButtonLabel?: string;
  onBackHomeClick?: () => void;
}

export const NotFound: React.FC<NotFoundProps> = ({
  hideBackHomeButton = false,
  backHomeButtonLabel,
  onBackHomeClick,
}) => {
  const navigate = useNavigate();

  const { translation } = useTranslationContext();

  const handleBackHomeClick = () => {
    if (onBackHomeClick) {
      onBackHomeClick();
      return;
    }
    navigate('/home');
  };

  return (
    <Stack
      height="100vh"
      justifyContent="center"
      alignItems="center"
      spacing={6}
      role="main"
      aria-labelledby="not-found-title"
    >
      <ResponsiveSVG
        svg={NotFoundImage}
        deviceWidth={{ desktop: '315px', tablet: '315px', mobile: '252px' }}
        alt="Page not found illustration"
      />
      <Stack spacing={1}>
        <Typography
          id="not-found-title"
          fontWeight={500}
          align="center"
          variant="extraLargeNumber"
          color="primary"
        >
          404
        </Typography>
        <Typography align="center" variant="title3" color="grey.800">
          {translation('four_zero_four_error')}
        </Typography>
      </Stack>
      {hideBackHomeButton ? null : (
        <Button variant="tertiary" onClick={handleBackHomeClick} aria-label="Back Home">
          {backHomeButtonLabel ?? translation('four_zero_four_error_back_home')}
        </Button>
      )}
    </Stack>
  );
};
